import { Route, Routes } from 'react-router-dom';
import InsuredCustomersReport from '../pages/admin-reports/insured-customers/InsuredCustomersReport';
import { ADMIN_REPORT_PATHS } from '../constants/routePaths';

const AdminReportsRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path={ADMIN_REPORT_PATHS.INSURED_CUSTOMERS} element={<InsuredCustomersReport />} />
      </Routes>
    </div>
  );
};
export default AdminReportsRoutes;
